import { render, staticRenderFns } from "./ProductContentSidebar.vue?vue&type=template&id=2079dce7&scoped=true&"
import script from "./ProductContentSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductContentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentSidebar.vue?vue&type=style&index=0&id=2079dce7&prod&scoped=true&lang=css&"
import style1 from "./ProductContentSidebar.vue?vue&type=style&index=1&id=2079dce7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079dce7",
  null
  
)

export default component.exports